<template>
  <el-dialog
    v-if="visible"
    v-el-dialog-drag
    show-close
    visible
    width="600px"
    :title="$l('INDEX.btn_tips_edit') || '编辑文档'"
    :close-on-click-modal="false"
    :before-close="() => close()"
  >
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row>
        <el-form-item
          :label="$l('label_file_type') || '文档类型'"
          prop="prjFileType"
        >
          <dict-select
            filterable
            v-model="formData.prjFileType"
            url="/sys/common/dict/system"
            :placeholder="$l('INDEX.tips_select_placeholder') || '请选择...'"
            clearable
            size="small"
            :body="{dictType: 'prjFileType'}"
          ></dict-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('label_file_desc') || '文档说明'"
          prop="prjFileDesc"
        >
          <el-input
            type="textarea"
            size="small"
            v-model="formData.prjFileDesc"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            clearable
            rows="3"
            maxlength="2000"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">{{
        $l('btn_cancel') || '取消'
      }}</el-button>
      <el-button type="primary" size="small" @click="save()">
        {{ $l('btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    visible: {type: Boolean, default: false},
    prjDocCode: {type: String, default: ''},
  },
  data() {
    return {
      formData: {
        prjDocCode: '',
        prjFileType: '',
        prjFileDesc: '',
      },
      rules: {
        prjFileType: [
          {
            required: true,
            message: this.$l('tips_select_file_type') || '请选择文档类型',
            trigger: 'change',
          },
        ],
        prjFileDesc: [
          {
            required: true,
            message: this.$l('tips_input_file_desc') || '请填写文档说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    visible() {
      if (!this.visible) return
      this.detail()
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .infoDocEditApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
          this.close()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    detail() {
      if (!this.prjDocCode || this.prjDocCode === '') return
      this.$api.infoDocDetailApi({prjDocCode: this.prjDocCode}).then((res) => {
        this.formData = res.body
      })
    },
  },
}
</script>
